import {
  Avatar,
  Box,
  Button,
  Text,
  TogglerCheckbox,
  useToggle,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const EXAMPLE_NAME = 'Malena Smith' as const

const EXAMPLE_DESCRIPTIONS = {
  hiring: () => (
    <Text.Normal>
      {i18n.t('payroll_bundle.onboarding.employee_updates_step.examples.new_hires')}
    </Text.Normal>
  ),
  contract: () => (
    <Text.Normal>
      <s>{'45.000 €'}</s> {'→ 50.000 €'}
    </Text.Normal>
  ),
  termination: () => (
    <Text.Normal>
      {i18n.t('payroll_bundle.onboarding.employee_updates_step.examples.termination')}
    </Text.Normal>
  ),
} as const

type ExampleKey = keyof typeof EXAMPLE_DESCRIPTIONS

const hasEventExample = (id: string): boolean => {
  return id in EXAMPLE_DESCRIPTIONS
}

export interface ItemProps {
  id: string
  title: string
  description: string
  disabled: boolean
  onTogglerChange: () => void
  active: boolean
  onSetValidation: () => void
  needsValidation?: boolean
  isSettings: boolean
}

const EmployeeUpdateItem = ({
  id,
  title,
  disabled,
  onTogglerChange,
  active,
  isSettings,
}: ItemProps) => {
  const [open, toggleModal] = useToggle(false)

  const hasExample = hasEventExample(id)

  return (
    <Box
      flexDirection="column"
      gap="s16"
      padding="s16"
      borderRadius={{ all: 'abs012' }}
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey300',
        },
      }}
    >
      <Box flexDirection="row" gap="s16" alignItems="center">
        <Box flexDirection="row" gap="s8">
          {!isSettings && (
            <Button
              type="secondary"
              disabled={!active}
              onClick={toggleModal(true)}
              iconName="settings"
            />
          )}
          <Box alignSelf="center">
            <TogglerCheckbox value={active} onChange={onTogglerChange} disabled={disabled} />
          </Box>
        </Box>
        <Box>
          <Text.Normal size="300" color="grey800" weight="medium">
            {title}
          </Text.Normal>
        </Box>
      </Box>

      {active && hasExample && (
        <Box
          flexDirection="row"
          alignItems="center"
          gap="s16"
          justifyContent="spaceBetween"
          background="grey200"
          paddingX="s16"
          paddingY="s12"
          borderRadius={{ all: 'abs012' }}
        >
          <Box flexDirection="row" alignItems="center" gap="s16">
            <Avatar
              color="purple"
              size="s32"
              label="malena"
              url="https://randomuser.me/api/portraits/women/21.jpg"
            />
            <Text.Normal>{EXAMPLE_NAME}</Text.Normal>
          </Box>
          {EXAMPLE_DESCRIPTIONS[id as ExampleKey]()}
        </Box>
      )}
    </Box>
  )
}

export default EmployeeUpdateItem
